import {
  CARD_ELEMENT_TYPE,
  PHOTO_TYPE,
} from '../../../../../../../services/cards/constants';
import { isCardElementEditable } from '../../../../../../../services/cards/components/AccountCard/helpers';
import { MAX_Z_INDEX } from '../../../../helpers';

export const BASE_LOGO_FRAME = {
  x: 0.3,
  y: 0.05,
  width: 0.4,
  height: 0.2,
};

/**
 * Determines whether an element is the Card's Logo.
 * We're using a photo element by default.
 *
 * @param {Object} element The element.
 * @returns {boolean}
 */
export const isElementCardLogo = element => {
  if (!element) {
    return false;
  }

  const { cardElement, cardElementConfiguration } = element;
  const isPhoto = cardElement.type === CARD_ELEMENT_TYPE.PHOTO;
  const isMaxZIndex = cardElement.z_index === MAX_Z_INDEX;
  const isEditable = isCardElementEditable(element);
  const isLogo = cardElementConfiguration?.photo_type === PHOTO_TYPE.LOGO;

  return isPhoto && (isLogo || (isMaxZIndex && !isEditable));
};
